// @flow
// @flow-runtime warn

export type PriceTypes =
  | 'price_base'
  | 'price_lk'
  | 'price_mobile'
  | 'price_sms'
  | 'price_email'
  | 'price_base_on_months'
  | 'price_sms_on_months'

export const priceTypes = {
  price_base: ('price_base': 'price_base'),
  price_lk: ('price_lk': 'price_lk'),
  price_mobile: ('price_mobile': 'price_mobile'),
  price_sms: ('price_sms': 'price_sms'),
  price_email: ('price_email': 'price_email'),
  price_base_on_months: ('price_base_on_months': 'price_base_on_months'),
  price_sms_on_months: ('price_sms_on_months': 'price_sms_on_months'),
};

export type PriceDiscountedRequestParams = {
  student_id: number,
  tariff_id?: number,
  tariff_bundle_id?: number,
  price_type: PriceTypes,
  months_number?: number, // для months_subscribes
}

export type PriceDiscountedRequestResult = string
